import { Link } from 'react-router-dom';
import { FormattedMessage, useIntl } from 'react-intl';
import { Icon } from 'ui';
import PublicRoute from 'enums/publicRoutes';
import { ProductBreadcrumb } from '../utils/productBreadcrumbs';

interface ProductBreadcrumbsProps {
  crumbs: ProductBreadcrumb[];
  backTo?: ProductBreadcrumb;
  onBack: () => void;
}

const ProductBreadcrumbs = ({
  crumbs,
  backTo,
  onBack,
}: ProductBreadcrumbsProps) => {
  const intl = useIntl();

  return (
    <div className={'product-nav'}>
      <button type={'button'} className={'product-back'} onClick={onBack}>
        <span className={'product-back-icon'}>
          <Icon name={'arrow-circle-left'} type={'any'} />
        </span>
        {backTo ? (
          <span>
            <FormattedMessage
              id={'product_view.back_to_category'}
              values={{
                category: (
                  <strong className={'product-back-target'}>
                    {backTo.name}
                  </strong>
                ),
              }}
            />
          </span>
        ) : (
          <span>{intl.formatMessage({ id: 'general.go_back' })}</span>
        )}
      </button>
      {!!crumbs.length && (
        <nav className={'product-breadcrumbs'}>
          <Link to={PublicRoute.HOME}>
            {intl.formatMessage({ id: 'breadcrumbs.home' })}
          </Link>
          {crumbs.map((crumb) => (
            <span key={crumb.id} className={'product-breadcrumb'}>
              <span className={'product-breadcrumb-separator'} aria-hidden>
                <Icon name={'breadcrumb-chevron'} type={'any'} />
              </span>
              <Link to={crumb.path}>{crumb.name}</Link>
            </span>
          ))}
        </nav>
      )}
    </div>
  );
};

export default ProductBreadcrumbs;
